export { ReactComponent as PdfObject } from './svgs/pdf-object.svg';
